import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';

import { ShareModule} from '../../shared/share.module';

import { AuthGuard } from '../../service/auth-guard.service';

import { RoleComponent } from './role/role.component';
import { RoleCrudComponent } from './role-crud/role-crud.component';
import { RoleListComponent } from './role-list/role-list.component';
import { RolesComponent } from './roles/roles.component';

import { RoleService } from './shared/role.service';

var permissionPage='admin.role';


export const RoleServices:Array<any>=[RoleService];
export const RoleComponents:Array<any>=[RoleListComponent,RoleComponent,RoleCrudComponent,RolesComponent];
export const RoleRoutes: Routes = [
  { path: 'role', component: RoleListComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'list'  } },
  { path: 'role/create', component: RoleCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'create' } },
  { path: 'role/:id', component: RoleCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'read' } },
  { path: 'role/:id/update', component: RoleCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'update' } },
  { path: 'role/:id/clone', component: RoleCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'clone' } }
];


@NgModule({
  imports: [ ShareModule ],
  declarations: [...RoleComponents],
  providers: [RoleService],
  exports: [...RoleComponents]
})
export class RoleModule { }



// WEBPACK FOOTER //
// ./src/app/module/role/role.module.ts